<template>
  <div id="app">
    <History
      :type="$route.name == 'search' || $route.name == 'history' ? 2 : 1"
      v-if="
        $route.name == 'law' ||
          $route.name == 'description' ||
          $route.name == 'search' ||
          $route.name == 'history'
      "
    ></History>
    <router-view></router-view>
  </div>
</template>

<script>
import { init } from "@/proxy/index";
import History from "@/components/History";
export default {
  components: {
    History
  },
  data() {
    return {};
  },
  created() {
    // 多语言配置
    const params = new URLSearchParams(window.location.search);
    let lang = params.get("lang") || localStorage.getItem("LOCAL_LANG");

    if(lang!=='en'&&lang!=='ph'&&lang!=='my'&&lang!=='id'){
        lang='en'
    }

    localStorage.setItem("LOCAL_LANG", lang);
    this.$i18n.locale = lang

    init().then(res => {
      if (res.data.code == 0) {
        this.$store.dispatch("setData", res.data.data);
      }
    });
  },
  mounted() {
    document.querySelector("#loadingMask").style.display = "none";
  }
};
</script>

<style lang="scss">
html,
body {
  width: 100%;
  height: 100%;
}

#app {
  position: relative;
  min-height: 100vh;
  @media screen and (min-width: $mimViewWidth) {
    background: url("./assets/images/bg.jpg") no-repeat;
    background-size: cover;
    background-position: center;
    background-attachment: fixed;
  }

  @media screen and (max-width: $maxViewWidth) {
    max-width: $maxViewWidth;
    overflow: auto;
    margin: auto;
    
    background: url("./assets/images/m/bg.jpg") no-repeat;
    background-size: cover;
    background-position: top center;
    background-attachment: fixed;
  }
}

@font-face {
  font-family: Impact;
  src: url("./assets/fonts/Impact.ttf") format("truetype");
}

</style>
